module.exports = __webpack_public_path__ + "img/variant-placeholder-image.d046c9f.svg";